<template>
  <v-layout
    row justify-start mb-2
    class="nx-image-focal-point-wrapper"
  >
    <v-flex>
      <v-switch
        v-model="manual"
        @change="changeMode"
        label="Punto focal manual"
        hide-details
      ></v-switch>
    </v-flex>

    <transition name="slide-x-reverse-transition">
      <v-flex shrink class="ml-3 mt-2" v-show="manual">
        <v-btn @click="openDialog" :disabled="disabled">
          <v-icon left>adjust</v-icon>
          Cambiar punto focal
        </v-btn>
      </v-flex>
    </transition>

    <nx-fullscreen-dialog
      v-if="dialogState.render"
      :active="dialogState.visible"
      title="Elegir punto focal"
      classes="nx-image-focal-point__modal-body"
      @dismiss="closeDialog"
      dismissable>
      <template slot="toolbar-items">
        <v-btn
          @click.native="accept"
          color="accent"
          flat dark
          :disabled="disabled"
        >{{ $t('message.common.accept') }}
        </v-btn>
      </template>

      <div class="nx-image-focal-point__wrapper" :class="{ visible: loaded}">
        <img class="nx-image-focal-point__space-reserver elevation-3" alt="Seleccionar punto de foco"
             :src="src" @load="init" ref="img">
        <div class="nx-image-focal-point__workspace" ref="container">
          <div class="nx-image-focal-point__handle" ref="handle" @mousedown="onMouseDown">
            <v-icon large color="white">adjust</v-icon>
          </div>
        </div>
      </div>

    </nx-fullscreen-dialog>

  </v-layout>
</template>

<script>
import NxFullscreenDialog from '@/components/dialogs/FullscreenDialog';
import FormElement from '@/modules/form/mixins/form-element';

const HANDLE_SIZE = 36;
const HALF_HANDLE_SIZE = HANDLE_SIZE / 2;
const delay = async miliseconds => new Promise(resolve => setTimeout(resolve, miliseconds));


export default {
  name: 'nx-image-focal-point',
  components: { NxFullscreenDialog },
  mixins: [FormElement],
  props: {
    src: {
      type: String,
    },
    value: {
      type: Object,
      required: false,
      validator(value) {
        if (value === null) return true;
        return typeof value === 'object' && 'x' in value && 'y' in value;
      },
    },
  },
  data() {
    return {
      manual: true,
      loaded: false,
      dialogState: {
        render: false,
        visible: false,
      },
      image: {},
      portrait: false,
      handle: { top: 0, left: 0 },
      container: {},
    };
  },
  methods: {
    changeMode(manual) {
      if (manual) {
        this.openDialog();
      } else {
        this.emitInput(null);
      }
    },
    openDialog() {
      window.addEventListener('mouseup', this.onMouseUp, true);
      this.dialogState.render = true;
      this.$nextTick(() => {
        this.dialogState.visible = true;
      });
    },
    closeDialog() {
      window.removeEventListener('mouseup', this.onMouseUp, true);
      this.dialogState.visible = false;
      this.$nextTick(() => {
        this.dialogState.render = false;
        this.loaded = false;
        this.handle = { top: 0, left: 0 };
        this.container = {};
        this.portrait = false;
      });
    },
    getHandleValue() {
      const top = this.handle.top;
      const left = this.handle.left;
      return {
        top: (top - HALF_HANDLE_SIZE) * 100 / this.container.height,
        left: (left - HALF_HANDLE_SIZE) * 100 / this.container.width,
        x: left * this.image.width / this.container.width,
        y: top * this.image.height / this.container.height,
      };
    },
    accept() {
      const value = this.getHandleValue();
      this.emitInput(value);
      this.closeDialog();
    },
    emitInput(value) {
      console.log('emiting', value);
      this.$emit('input', value);
      if (this.$parentForm && this.$parentForm.updateField) {
        this.$parentForm.updateField(this.name, value);
      }
    },
    async init() {
      const $image = this.$refs.img;
      this.image.width = $image.naturalWidth;
      this.image.height = $image.naturalHeight;
      await delay(1000); // Wait until everything is drawed!

      this.container = this.$refs.container.getBoundingClientRect();

      console.log('Initialized component!');
      console.log(`  Workspace: ${this.container.width} x ${this.container.height} (${this.container.width / this.container.height})`);
      console.log(`  Nat Image: ${this.image.width} x ${this.image.height} (${this.image.width / this.image.height})`);
      console.log(` Draw Image: ${$image.width} x ${$image.height} (${$image.width / $image.height})`);

      if (this.value) {
        this.handle = {
          left: this.value.x * this.container.width / this.image.width,
          top: this.value.y * this.container.height / this.image.height,
        };
        this.$refs.handle.style.top = `${this.handle.top}px`;
        this.$refs.handle.style.left = `${this.handle.left}px`;
        console.log(`     Handle: ${this.value.x} x ${this.value.y}`);
        console.log(`     Handle: ${this.handle.left} x ${this.handle.top}`);
      }

      this.loaded = true;
    },
    onMouseDown() {
      // When the user clicks on the handle, a new event listener will be added to track the mouse movement.
      window.addEventListener('mousemove', this.onMouseMove, true);
    },
    onMouseUp() {
      // When the mouse is released, remove the event listener.
      window.removeEventListener('mousemove', this.onMouseMove, true);
      console.log('Nueva posición: ', this.handle, this.getHandleValue());
    },
    onMouseMove(evt) {
      const newTop = evt.clientY - this.container.y - HALF_HANDLE_SIZE;
      const newLeft = evt.clientX - this.container.x - HALF_HANDLE_SIZE;
      this.handle.top = Math.max(Math.min(newTop, this.container.height - HANDLE_SIZE), 0);
      this.handle.left = Math.max(Math.min(newLeft, this.container.width - HANDLE_SIZE), 0);

      this.$refs.handle.style.top = `${this.handle.top}px`;
      this.$refs.handle.style.left = `${this.handle.left}px`;
    },
  },
  watch: {
    value: {
      handler(newValue) {
        this.manual = !!newValue;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="stylus">
.nx-image-focal-point {
  &__modal-body {
    max-height: calc(100vh - 64px);
    height: calc(100vh - 64px);
    max-width: 100%
    width: 100%
    font-size: 0
    text-align: center
    user-select: none;
    background-color: rgba(0, 0, 0, .2)
  }
  &__wrapper {
    max-height: calc(100vh - 64px);
    max-width: 100%
    display: inline-block
    position: relative
    opacity: 0

    &.visible {
      transition opacity 0.2s ease-in
      opacity: 1
    }
  }
  &__space-reserver {
    max-width: 100%
    max-height: calc(100vh - 64px);
    object-fit: contain
  }
  &__workspace {
    position: absolute;
    top: 0
    left: 0
    right: 0
    bottom: 0
    background-color: rgba(0, 0, 0, .4)
  }
  &__handle {
    position absolute;
    cursor: move;
    top: 0
    left: 0
  }
}
</style>
